export default __webpack_public_path__ + "static/media/paper.67d6c9e4.svg";